import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=8b68283e&scoped=true&"
import script from "./InputCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=8b68283e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b68283e",
  null
  
)

export default component.exports